import scroll from "scroll";

/**
 * 使滚动容器滚动到指定dom位置
 * @param scrollContainer 可滚动的容器，position不应该是static
 * @param target 要滚动的目标元素
 * @param offset 偏移位置
 */
export function scrollTop(scrollContainer, target, offset = 0) {
    scroll.top(scrollContainer, target.offsetTop + offset)
}
